function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M59.775 68.148a8.347 8.347 0 0 1-5.918-2.451L2.452 14.292a8.372 8.372 0 1 1 11.84-11.84l45.483 45.485L105.26 2.453a8.372 8.372 0 0 1 11.838 0 8.369 8.369 0 0 1 0 11.84L65.694 65.698a8.347 8.347 0 0 1-5.919 2.45z",
  fill: "currentColor"
});
var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 119.551 68.148"
  }, props), _ref);
};
export default __webpack_public_path__ + "static/media/chevron-down.339ff332.svg";
export { SvgComponent as ReactComponent };